<template>
    <media-buttons 
        :container-class="containerClass"
        :options="estate.media" 
        :active="active"
        :icons="true"
        :decore-active="false"
        @selected="mediaSelected"
    />
</template>

<script>
import MediaButtons from './MediaButtons'

export default {
    components: {
        'media-buttons': MediaButtons,
    },

    props:{
        first_active:{
            type: String,
            default: 'images'
        },

        estate:{
            type: Object,
            required:  true,
        },

        containerClass:{
            type:String,
            required: false
        }

    },

    data(){
        return {
            active: this.first_active,
        }
    },

    methods:{
        mediaSelected(event){
            this.active = event

            window.events.$emit('showModal', { 
                name: 'media-gallery', 
                data:{
                    estate: this.estate,
                    first_active: event,
                    buttons: true
                },
            })
        },
    }

}
</script>

<style>

</style>